
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/for-community",
      function () {
        return require("private-next-pages/for-community.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/for-community"])
      });
    }
  